import {
  useConversationActions,
  useConversationState,
} from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { MessagePost } from '@web/conversations/types/Message';

export const useQuotedMessagePreview = () => {
  const { unselectQuotedMessage } = useConversationActions();
  const { messages, quotedMessageId } = useConversationState();

  const quotedMessage = messages.byId[quotedMessageId] as MessagePost;

  return {
    quotedMessage,
    unselectQuotedMessage: () => unselectQuotedMessage(),
  };
};
